/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {CachedResourceLoader as Éµangular_packages_platform_browser_dynamic_platform_browser_dynamic_a} from './src/resource_loader/resource_loader_cache';